import React, { Component } from 'react';
import { connect } from 'react-redux'
import { VALIDATING_TELEPHONY } from '../../../constants'
import { retryFirstCall } from '../../../redux/actions/A_messages_to_SM';
import { changeState } from '../../../redux/actions/A_user_states';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { secondsToFormat } from '../../../js/helpers/Utils/formats';
import { validatingTelephony, validTelephony, invalidTelephony } from '../../../Images/Images';
import { Image } from 'react-bootstrap';
import { Singleton } from '../../../js/Singleton';
import TelValidationSound from '../../../audios/TelValidationSound.mp3'
import { Logger } from '../../../js/helpers/Logger'
import SingletonWebSocket from '../../../js/Singletons/SingletonWebSocket';
class ValidatingTelephonyLocked extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: "",
      timeOut: false,
      validating: false,
      telephonyValid: false
    };
    this.timerTime = {};
    this.sharedData = new SingletonSharedData();
    this.language = new Singleton();
    this.audio = new Audio(TelValidationSound);
  }

  componentWillReceiveProps(nextProps) {
    clearInterval(this.timerTime);
    this.setState({
      timeOut: false,
      time: nextProps.validatingTelephonyState.time
    });
    let _this = this;
    let telephonyState=null;
    switch (nextProps.validatingTelephonyState.currentState) {
      case VALIDATING_TELEPHONY.VALIDATING:
        this.setTimer();
        this.setState({
          validating: true
        });
        telephonyState="Validating";
        break;
      case VALIDATING_TELEPHONY.VALID:
        this.audio.play();
        this.setState({
          telephonyValid: true
        });
        nextProps.setIsLogged(true);
        telephonyState="Valid";
        break;
      case VALIDATING_TELEPHONY.ERROR:
        this.sharedData.setLogged(false);
        Logger.Debug("[validatingTelephony][VALIDATING_TELEPHONY.ERROR] setLogged False");
        nextProps.setIsLogged(false);
        this.setState({
          timeOut: true,
          telephonyValid: false
        });
        telephonyState="Error";
        break;
      default:
        break;
    }
    const integrationMessage = { client: "galatea", data: telephonyState, action: "onTelephonyStatus" };
    SingletonWebSocket.send(integrationMessage);
  }

  setTimer() {
    var _this = this;
    this.timerTime = setInterval(timeMethod, 1000);
    function timeMethod() {
      _this.setState({
        time: _this.state.time - 1
      });
      if (_this.state.time <= 0) {
        clearInterval(_this.timerTime);
        _this.setState({ timeOut: true });
      }  
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerTime);
  }

  retry() {
    this.props.retryFirstCall(this.sharedData.getUserData().Login, this.sharedData.getParameters().UserID);
  }

  render() {
    return (
      <div className="noAvailableLocked">
        <div className="validatingTelephony" style={{ position: 'absolute', bottom: 'calc(50% - 115px)', right: 'calc(50% - 90px)' }}>
          <div className={this.state.timeOut ? "NotValidAnimation" : this.state.telephonyValid ? "ValidAnimation" : "ValidatingAnimation"}>
            <div className="circle1"></div>
            <div className="circle2"></div>
            <Image src={this.state.timeOut ? invalidTelephony : this.state.telephonyValid ? validTelephony : validatingTelephony}
              className="animationValidating" />
          </div>
          <p className={this.state.timeOut ? "TitleNotValid" : this.state.telephonyValid ? "TitleValid" : "TitleValidating"}>
            {this.state.timeOut ? this.language.getText('GUITelephonyValidatorerrorValTitle') : this.state.telephonyValid ? this.language.getText('GUITelephonyValidatorvalidTitle') : this.language.getText('GUITelephonyValidatorvalTitle')}</p>
          {this.state.timeOut ?
            <input className="buttonValidating" type="submit" value={this.language.getText('GUITelephonyValidatorreconnect')} onClick={() => this.retry()} /> :
            this.state.telephonyValid ? "" :
              <p className={"timeValidating " + (this.state.validating ? "" : "validating")}>{(this.state.validating ? secondsToFormat(this.state.time, false) : this.language.getText('GUITelephonyValidatorwaitingTitle'))}</p>
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    validatingTelephonyState: state.validatingTelephonyState,
    messagesIntegrations: state.messagesIntegrations
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    retryFirstCall: (userName, userID) => { dispatch(retryFirstCall(userName, userID)); },
    changeState: (newState) => { dispatch(changeState(newState)); }
  });
}

export default ValidatingTelephonyLocked = connect(
  mapStateToProps,
  mapDispatchToProps
)(ValidatingTelephonyLocked);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/validatingTelephony.jsx